import { Box, Button } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useEffect, useState } from "react";
import { get, isEmpty } from "lodash";
import { useNavigate , useParams } from "react-router-dom";
import { FormState, UseFormWatch } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";
import dayjs from "dayjs";
import { nanoid } from 'nanoid';

import {
  PatientHeaderTabs,
  ReferralGrid,
  DetailBox,
  width100PCT,
  CancelButtonGrid,
  NextButtonGrid,
  ButtonMinWidth,
  PatientHeaderTab,
  ButtonMinWidth_Outlined,
} from "../../PriorAuthWorkFlow/styles/style";
import {
  a11yProps,
  appendTimestampToFilename,
  currentDate,
  decryptId,
  encryptId,
  getCurrnetPageFullPath,
  getFormattedDateTime,
  getSessionStorage,
  getUaserPageViewPayload,
  getValue,
} from "../../../utils";
import { flexAlignCentre } from "../../../styles/mui/styles/display";
import {
  ReAuthTabData,
  notVisitedReAuthTabs,
} from "../../../models/TabSessionStorage";
import AlertDialog from "../../PriorAuthWorkFlow/components/AlertDialog";
import ConfirmationDialog from "../../PriorAuthWorkFlow/components/ConfirmationDialog";
import ErrorDialog from "../../PriorAuthWorkFlow/components/ErrorDialog";
import {
  confirmationMessage,
  Constants,
  DisciplineTableHeader,
  IngestProcessActionDispatchTypes,
  Numbers,
  PostReAuthRequestDispatchTypes,
  ReAuthDetailsPayload,
  ReAuthHeaderLabel,
  ReAuthorizationValuesForIngest,
  ReferralDocumentFileDispatchTypes,
  RequestReAuthTabCount,
  RequestTabCount,
  SaveDetailsAlertMessage,
  SlotsDispatchTypes,
} from "../../../constants/Referral";
import { TabSessionDataReAuthResponse } from "../../../models/api/TabSessionStorage";
import { ApplicationRoute } from "../../../constants/ApplicationUrl";
import {
  EligibilityCheckActionDispatchTypes,
  InformationActionDispatchTypes,
  MemberInfoDataActionDispatchTypes,
  PatientFromMbiActionDispatchTypes,
  PatientInformationByIdActionDispatchTypes,
} from "../../../constants/Patient";
import { Discipline, ListOptions } from "../../../models/Master";
import { MyAccountModel } from "../../../models/MyAccount";
import { ServiceProvider } from "../../../models/ServiceProvider";
import { AgencyListPayload } from "../../../models/ProviderMaterials";
import { formatDate } from "../../../utils/DateTime";
import { DateFormats } from "../../../constants/Date";
import {
  MemberInfoData,
  Patient,
  PatientInformation,
} from "../../../models/Patient";
import { TabSessionStorageReAuthDispatchTypes } from "../../../constants/TabSessionStorage";
import {
  MessageType,
  ResponseMessages,
} from "../../../constants/ResponseMessage";
import {
  DocumentsUploadsResponse,
  DocumentUpload as DocumentUploadResponse,
  PostReAuthRequestResp,
  ReAuthDefaultReferralDetails,
} from "../../../models/Referral";
import {
  callDocumentErrorSwal,
  callFailedSwalVisible,
  callSuccessSwalVisible,
} from "../../../app/common/DocumentListStatus";
import { flattenApiValidationErrors, showMessageModal, TabsPanelSection } from "../../../app/common";
import SweetAlert from "../../../components/AuthFormComponents/SweetAlert";
import { getValidMessageType } from "../../../constants/User";
import { ApplicationTitles } from "../../../constants/HomePage";
import { redirectUri } from "../../../constants/Config";
import { UserPageTrack } from "../../../models/User";
import AgencyDetails from "../containers/AgencyDetails";
import DocumentUpload from "../containers/DocumentUpload";
import Review from "./Review";
import ICD10 from "../containers/ICD10";
import PhysicianDetails from "../containers/PhysicianDetails";
import RequestServices from "../containers/RequestServices";
import { ReAuthIngestPayload } from "../../../models/ReAuth";
export interface PropsFromState {
  setCurrentTab: (id: number) => void;
  tabSessionStorage: TabSessionDataReAuthResponse;
  currentTab: number;
  getValues: any;
  reset: any;
  setValue: any;
  control: any;
  clearErrors: any;
  formError: any;
  masterServiceProviderState: ListOptions[];
  masterSendCommunicationAuthTypeState: ListOptions[];
  loggedInUser: MyAccountModel;
  serviceProviderListWithDetails: ServiceProvider[];
  handleSubmit: () => any;
  trigger: any;
  masterReferralSourceState: ListOptions[];
  values: any;
  watch: UseFormWatch<ReAuthTabData>;
  formState: FormState<any>;
  errors: any;
  patientFromMbiState: Patient;
  memberInfoDataState: MemberInfoData;
  setReimbursementTypeId: (id: number) => void;
  reimbursementTypeId: number;
  disciplineListState: Discipline[];
  ingestProcessState: any;
  ingestProcessErrorState: any;
  documentUploadState: DocumentUploadResponse;
  documentUploadErrorState: any;
  patientInformationByIdState: PatientInformation;
  icd10RecordsFields: any[];
  icd10RecordsAppend: object;
  icd10RecordsRemove: (id: number) => void;
  reAuthSubmitState: PostReAuthRequestResp;
  reAuthSubmitErrorState: any;
  reAuthReferralDetailState: ReAuthDefaultReferralDetails;
}
export interface PropsFromDispatch {
  saveTabSessionStorage: (sessionData: ReAuthTabData) => void;
  resetStates: (type: string) => void;
  handleSubmit: () => any;
  getMasterServiceProvider: (payload: AgencyListPayload) => void;
  getSendCommunicationAuthType: () => void;
  setFileUpload: (files: File[]) => void;
  ingestProcess: (formData: FormData) => void;
  fileUpload: File[];
  uploadDocumentFile: (formData: FormData) => void;
  postUserPageTrack: (payload: UserPageTrack) => void;
  postReAuthSubmit: (payload: ReAuthDetailsPayload) => void;
}

type AllProps = PropsFromState & PropsFromDispatch;

const ReAuthTabs: React.FC<AllProps> = ({
  setCurrentTab,
  currentTab,
  resetStates,
  formError,
  reset,
  handleSubmit,
  fileUpload,
  tabSessionStorage,
  loggedInUser,
  ingestProcessState,
  ingestProcessErrorState,
  reAuthSubmitErrorState,
  documentUploadState,
  documentUploadErrorState,
  uploadDocumentFile,
  postUserPageTrack,
  control,
  setValue,
  getValues,
  masterSendCommunicationAuthTypeState,
  setFileUpload,
  values,
  watch,
  icd10RecordsFields,
  icd10RecordsAppend,
  icd10RecordsRemove,
  clearErrors,
  formState,
  memberInfoDataState,
  patientInformationByIdState,
  ingestProcess,
  postReAuthSubmit,
  reAuthSubmitState,
  trigger,
  reAuthReferralDetailState,
}: AllProps) => {
  const [activeTab, setActiveTab] = useState(0);
  const [isNextStep, setIsNextStep] = useState<boolean>(false);
  const [isTabChange, setIsTabChange] = useState(false);
  const [backClick, setBackClick] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [hasFormError, setHasFormError] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [consolidatedErrors, setConsolidatedErrors] = useState<any>([]);
  const { email, userName, firstName, lastName } = getValue(loggedInUser, "providerPortalUser", {});
  const { providerId} = useParams();
  const [showAlert, setShowAlert] = useState<{
    message1: any;
    message2: any;
  } | null>(null);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [apiValidationErrors, setApiValidationErrors] = useState<string[]>([]);

   const actualReferralId = reAuthReferralDetailState.referralId ?
    !isEmpty(getSessionStorage("samlToken")) ? encryptId(reAuthReferralDetailState.referralId) : reAuthReferralDetailState.referralId
    : null;

  useEffect(() => {
    if (currentTab === RequestTabCount) {
      setCurrentTab(activeTab);
    }
  }, [activeTab]);

  useEffect(() => {
    const formErrorLength = !isEmpty(get(formError, "response.sessionData", {}))
      ? Object.keys(get(formError, "response.sessionData", {})).length
      : 0;
    if (
      isTabChange &&
      formError &&
      !formError.loading &&
      formError.error &&
      Object.keys(formError.error).length === 0 &&
      formErrorLength >= 0
    ) {
      if (currentTab < RequestTabCount && currentTab !== RequestTabCount) {
        setCurrentTab(activeTab);
        setOpenAlert(false);
      }
      if (currentTab === RequestTabCount) {
        setCurrentTab(activeTab);
        setOpenAlert(false);
      }
      setIsTabChange(false);
    } else if (
      (isNextStep || backClick) &&
      formError &&
      !formError.loading &&
      formError.error &&
      Object.keys(formError.error).length === 0 &&
      formErrorLength >= 0
    ) {
      if (currentTab < RequestTabCount && currentTab !== RequestTabCount) {
        backClick && setCurrentTab(currentTab - 1);
        isNextStep && setCurrentTab(currentTab + 1);
      }
      if (currentTab === RequestTabCount) {
        setCurrentTab(activeTab);
      }
      setIsNextStep(false);
    }
  }, [formError]);

  const handleChange = async (
    _event: React.SyntheticEvent,
    newValue: number
  ) => {
        const isValid = await trigger();
    if (!isValid) {
      setHasFormError(true);
      const extractErrors = (errorsObj: any, parentKey = ""): any[] => {
        return Object.entries(errorsObj).flatMap(([key, value]) => {
          if (
            value &&
            typeof value === "object" &&
            ("message" in value || "type" in value)
          ) {
            return [{
              name: parentKey ? `${parentKey}.${key}` : key,
              message: (value as { message?: string }).message,
              type: (value as { type?: string }).type,
            }];
          } else if (value && typeof value === "object") {
            return extractErrors(value, parentKey ? `${parentKey}.${key}` : key);
          }
          return [];
        });
      };
      const rootErrors = extractErrors(formState.errors);

      if (rootErrors.length > 0) {
        setConsolidatedErrors(rootErrors);
      } else {
        setConsolidatedErrors(formState.errors);
      }
      return;
    }
    if (currentTab !== RequestTabCount) {
      setOpenAlert(true);
    }
    setActiveTab(newValue);
  };

  const handleNextStep = () => {
    handleSubmit();
    setIsTabChange(false);
    setIsNextStep(true);
  };

  const handleBackStep = () => {
    if (currentTab === RequestTabCount) {
      setCurrentTab(currentTab - 1);
    } else {
      handleSubmit();
      setBackClick(true);
    }
  };

  const handleSave = () => {
    handleSubmit();
    setIsTabChange(true);
    setOpenAlert(false);
  };

  const handleBackClick = () => {
    setOpenAlert(true);
    setBackClick(false);
    handleSubmit();
    if (currentTab !== 0) {
      setCurrentTab(currentTab - 1);
    }
  };

  const handleSubmitReferral = () => {
    const tabAndPatientData = tabSessionStorage.response;
    const transDate = new Date().toISOString();
    const requestUuid: string = uuidv4();

    const getPatientDetailsValuefromReauth = ReAuthorizationValuesForIngest(
      tabAndPatientData,
      patientInformationByIdState,
      requestUuid,
      loggedInUser,
      transDate
    );
    const getCurrentVisits = (discipline: string, visitType: "currentVisit" | "nextVisit") => {
      const visit =
        tabAndPatientData.requestService.disciplines
          .filter((item) => item.discipline === discipline)
          .map((disc) => disc[visitType])[0] || 0;
      return visit;
    };
    if (memberInfoDataState && getValue(memberInfoDataState, "isIngest")) {
      const ingestPayload: ReAuthIngestPayload = {
        ReferralId: tabAndPatientData.referralId,
        EligibilityCheck: {
          LastName: memberInfoDataState?.lastName,
          DateOfBirth: memberInfoDataState?.dob,
          SubscriberId: memberInfoDataState?.subscriberId ?? "",
          PayerName: memberInfoDataState?.healthPlan,
        },
        MemberDetails: {
          MemberName: patientInformationByIdState.patientName,
          SubscriberId: memberInfoDataState.subscriberId ?? "",
          Address:
            patientInformationByIdState.addressInfo.residentialAddress ?? "",
          PhoneNumber: patientInformationByIdState.memberInfo.phoneNo ?? "",
          DateOfBirth: memberInfoDataState?.dob,
          MBI:
            patientInformationByIdState.memberInfo
              .medicareBeneficiaryIdentifier ?? null,
          MemberPreferredLanguage:
            patientInformationByIdState.memberInfo.languageName ?? "",
          Gender: patientInformationByIdState.memberInfo.gender ?? "",
          HealthPlanName:
            patientInformationByIdState.memberInfo.healthPlan ?? "",
        },
        RequestDetails: {
          DateOfRequest: formatDate(currentDate(true), DateFormats.MM_DD_YYYY),
          StartOfCare:
            formatDate(
              tabAndPatientData.requestService.startOfCare,
              DateFormats.MM_DD_YYYY,
              DateFormats.YYYY_MM_DD,
              true
            ) ?? "",
        },
        AgencyDetails: {
          AgencyName: tabAndPatientData.reAuthAgencyDetails.requesterName,
          AgencyNPI: tabAndPatientData.reAuthAgencyDetails.requesterNpi,
          AgencyPhone: tabAndPatientData.reAuthAgencyDetails.requesterPhoneNo,
          AgencyFax: tabAndPatientData.reAuthAgencyDetails.requesterFax,
          AgencyAuthPreference:
            tabAndPatientData.reAuthAgencyDetails.sendApprovedAuthTo,
        },
        PatientClinicianInformation: {
          FirstName: patientInformationByIdState.patientFirstName,
          LastName: patientInformationByIdState.patientLastName,
          DateOfBirth: memberInfoDataState?.dob,
          Address:
            patientInformationByIdState.addressInfo.residentialAddress ?? "",
        },
        OrderingPhysician: {
          Name: tabAndPatientData.followingPhysicianDetail.physicianName,
          NPI: tabAndPatientData.followingPhysicianDetail.physicianNpiId,
          Phone: tabAndPatientData.followingPhysicianDetail.phoneNo,
        },
        AdditionalVisits: {
          SN: getCurrentVisits("SN", "currentVisit"),
          PT: getCurrentVisits("PT", "currentVisit"),
          OT: getCurrentVisits("OT", "currentVisit"),
          ST: getCurrentVisits("ST", "currentVisit"),
          MSW: getCurrentVisits("MSW", "currentVisit"),
          HHA: getCurrentVisits("HHA", "currentVisit"),
        },
        UploadedByUserEmail: email,
        SubmittedBy: userName,
        SubmittedDate: transDate,
        NoteComment: tabAndPatientData.noteComment,
        GroupId: getValue(memberInfoDataState, "groupId", null),
      };

      submitIngestProcess(
        ingestPayload,
        getPatientDetailsValuefromReauth,
        requestUuid
      );
    } else if (fileUpload.length > 0) {
    const memberAdmitted = getValue(tabSessionStorage, "response.requestService.memberAdmitted");
    const inpatientAdmitDate = formatDate(
      getValue(tabSessionStorage, "response.requestService.inpatientAdmitDate"),
      DateFormats.MM_DD_YYYY
    );
    const inpatientDischargeDate = formatDate(
      getValue(tabSessionStorage, "response.requestService.inpatientDischargeDate"),
      DateFormats.MM_DD_YYYY
    );
    const memberVisit = getValue(tabSessionStorage, "response.requestService.memberVisit");
    const emergencyVisitDate = formatDate(
      getValue(tabSessionStorage, "response.requestService.visitDate"),
      DateFormats.MM_DD_YYYY
    );

      const noteComment = tabAndPatientData.noteComment;
      const noteCommentDetails = [
        noteComment && noteComment.length > 0 ? noteComment : null,
        `${DisciplineTableHeader.MEMBER_ADMITTED} : ${memberAdmitted}`,
        `Inpatient Admit Date : ${inpatientAdmitDate}`,
        `Inpatient Discharge Date : ${inpatientDischargeDate}`,
        `${DisciplineTableHeader.MEMBER_EMERGENCY} : ${memberVisit}`,
        `Emergency Visit Date : ${emergencyVisitDate}`,
        `Secondary Address : ${getValue(tabSessionStorage, "response.reAuthAgencyDetails.secondaryEmailAddress")}`,
      ]
        .filter((item) => item !== null && item !== "" && item !== undefined)
        .join(", ");
      
      const createReAuthDisciplineList = (tabAndPatientData: ReAuthTabData) => {
        return tabAndPatientData.requestService.disciplines.map((disc) => ({
          disciplineId: disc.disciplineId,
          disciplineName: disc.discipline,
          serviceNumber: 0,
          currentRequestedVisit: getCurrentVisits(
            disc.discipline,
            "currentVisit"
          ),
          nextRequestedVisit: getCurrentVisits(disc.discipline, "nextVisit"),
          totalRequestedVisit:
            getCurrentVisits(disc.discipline, "currentVisit") +
            getCurrentVisits(disc.discipline, "nextVisit"),
          endDateOfExistingDiscipline: !isEmpty(disc.date)
            ? dayjs(disc.date).startOf("day").format(DateFormats.YYYY_MM_DDTHH_mm_ss)
            : null,
          currentStartDate: getValue(
            tabAndPatientData,
            "requestService.currentStartDate"
          ),
          currentEndDate: getValue(
            tabAndPatientData,
            "requestService.currentEndDate"
          ),
          nextStartDate: getValue(
            tabAndPatientData,
            "requestService.nextStartDate"
          ),
          nextEndDate: getValue(
            tabAndPatientData,
            "requestService.nextEndDate"
          ),
        }));
      };

    const payload = {
      requestId: requestUuid,
      userCreated: email,
      referralId: patientInformationByIdState?.referralId,
      noteComment: `${noteCommentDetails}`,
      fullName: patientInformationByIdState?.patientName,
      reAuthRequest: {
        referralId: patientInformationByIdState?.referralId,
        patientEligibilityId: patientInformationByIdState?.patientEligibilityId,
        receivedMethodId: 6,
        urgencyId: 1,
        userNameCreated: `${firstName} ${lastName}`,
        userEmail: email,
        userPhone: "",
        facilityTypeId: 8,
        userCreated: Constants.SYSTEM_USER,
        sendApprovedAuthTo: tabAndPatientData.reAuthAgencyDetails.sendApprovedAuthTo,
        secondaryEmailAddress: tabAndPatientData.reAuthAgencyDetails.secondaryEmailAddress,
      },
      followingPhysicianDetail: {
        serviceRequestId: 0,
        referralId: patientInformationByIdState?.referralId,
        physicianName:
          tabAndPatientData.followingPhysicianDetail.physicianName.replace(
            /[^a-zA-Z0-9\s]/g,
            ""
          ),
        physicianNpiId:
          tabAndPatientData.followingPhysicianDetail.physicianNpiId,
        phoneNo: tabAndPatientData.followingPhysicianDetail.phoneNo,
        county: tabAndPatientData.followingPhysicianDetail.county,
        zipCode: tabAndPatientData.followingPhysicianDetail.zipCode,
        userNameCreated: email,
        streetName1: tabAndPatientData.followingPhysicianDetail.streetName1,
        streetName2: tabAndPatientData.followingPhysicianDetail.streetName2,
        city: tabAndPatientData.followingPhysicianDetail.city,
        physicianState: tabAndPatientData.followingPhysicianDetail.physicianState,
        fax: tabAndPatientData.followingPhysicianDetail.fax,
      },
      reAuthServiceRequest: {
        serviceRequestId: 0,
        referralId: patientInformationByIdState?.referralId,
        startOfCareDate: formatDate(
          dayjs(tabAndPatientData.requestService.startOfCare).format(
            DateFormats.YYYY_MM_DD
          ),
          DateFormats.YYYY_MM_DD,
          DateFormats.YYYY_MM_DD,
          true
        ),
        startOfCareVerified: getValue(reAuthReferralDetailState, "startOfCareVerified"),
        currentStartDate: getValue(tabAndPatientData, "requestService.currentStartDate"),
        currentEndDate: getValue(tabAndPatientData, "requestService.currentEndDate"),
        nextStartDate: getValue(tabAndPatientData, "requestService.nextStartDate"),
        nextEndDate: getValue(tabAndPatientData, "requestService.nextEndDate"),
        userCreated: email,
        endDateOfExistingDisciplines: "",//TBD
        reAuthDiscipline: createReAuthDisciplineList(tabAndPatientData),
        fullNameCreated: email,
        currentDate: currentDate(true),
        highestCred: null,
      },
      icdCodesDetails: {
        ...tabAndPatientData.icdCodesDetails,
        icdCodesInfoDto: tabAndPatientData.icdCodesDetails.icdCodesInfoDto.map(
          (item: any) => ({
            ...item,
            referralIcdCodeId: item.referralIcdCodeId,
            diagnosisTypeId: item.diagnosisTypeId,
            diagnosisCode: item.diagnosisCode,
            diagnosisCodeDescription: item.diagnosisCodeDescription,
            icdDiagnosisCodeId: item.icdDiagnosisCodeId,
          })
        ),
      },
      PayerName: memberInfoDataState.healthPlan,
      authorizationNumber: reAuthReferralDetailState.authorizationNumber,
    };
      if (!isEmpty(payload.authorizationNumber)) {
        postReAuthSubmit(payload);
      }
    }
  };
  const submitIngestProcess = (
    submissionContent: ReAuthIngestPayload,
    getPatientDetailsValuefromReauth: any,
    requestUuid: string
  ) => {
    const formData = new FormData();
    formData.append("SubmissionSource", "2");
    formData.append("SubmissionContent", JSON.stringify(submissionContent));
    formData.append("UserId", email);
    fileUpload.forEach((file: File) => {
      formData.append("Files", file);
    });
    formData.append(
      "FullName",
      patientInformationByIdState && patientInformationByIdState?.patientName
    );
    formData.append("AuthorizationType", "ReAuth");
    formData.append("RequestId", requestUuid);
    formData.append("UserCreated", email);
    formData.append(
      "PortalRequestDetail",
      JSON.stringify(getPatientDetailsValuefromReauth)
    );

    ingestProcess(formData);

    recordPageTrack();
  };
  const navigate = useNavigate();
  const handleCancel = () => {

    const tempReferralId = !isEmpty(getSessionStorage("samlToken")) ? actualReferralId && decryptId(actualReferralId) : reAuthReferralDetailState.referralId;
    const validReferralId = !isEmpty(getSessionStorage("samlToken")) ? tempReferralId && encryptId(tempReferralId) : tempReferralId;

    const tempProviderId = !isEmpty(getSessionStorage("samlToken")) ? providerId && decryptId(providerId) : providerId;
    const validaProviderId = !isEmpty(getSessionStorage("samlToken")) ? tempProviderId && encryptId(tempProviderId) : tempProviderId;

    navigate(`${ApplicationRoute.RE_AUTH_MEMBER_INFO}/${validReferralId}/${validaProviderId}`);
  };

  const recordPageTrack = () => {
    postUserPageTrack(
      getUaserPageViewPayload(
        getValidMessageType(ApplicationTitles.CREATE_REAUTH),
        getCurrnetPageFullPath(),
        redirectUri,
        fileUpload.map((file) => file.name).join(",")
      )
    );
  };
  const resetAPIResponse = (type?: number) => {
    [
      MemberInfoDataActionDispatchTypes.MEMBER_INFO_DATA_RESET,
      EligibilityCheckActionDispatchTypes.ELIGIBILITY_CHECK_RESET,
      PatientFromMbiActionDispatchTypes.PATIENT_FROM_MBI_RESET,
      PatientInformationByIdActionDispatchTypes.PATIENT_INFORMATION_BY_ID_RESET,
      InformationActionDispatchTypes.INFORMATION_RESET,
      SlotsDispatchTypes.SLOTS_RESET,
      TabSessionStorageReAuthDispatchTypes.SET_TAB_DATA_RE_AUTH_RESET,
      ReferralDocumentFileDispatchTypes.REFERRAL_DOCUMENT_RESET,
      PostReAuthRequestDispatchTypes.POST_RE_AUTH_REQUEST_RESET,
      IngestProcessActionDispatchTypes.INGEST_PROCESS_RESET,
    ].forEach((actionType) => resetStates(actionType));
    if (type === Numbers.ONE) {
      const tempReferralId = !isEmpty(getSessionStorage("samlToken")) ? actualReferralId && decryptId(actualReferralId) : reAuthReferralDetailState.referralId;
      const validReferralId = !isEmpty(getSessionStorage("samlToken")) ? tempReferralId && encryptId(tempReferralId) : tempReferralId;
      const tempProviderId = !isEmpty(getSessionStorage("samlToken")) ? providerId && decryptId(providerId) : providerId;
      const validProviderId = !isEmpty(getSessionStorage("samlToken")) ? tempProviderId && encryptId(tempProviderId) : tempProviderId;
      navigate(`${ApplicationRoute.RE_AUTH_MEMBER_INFO}/${validReferralId}/${validProviderId}`);
    }
  };

  /**Document Upload */
  const handleSaveFile = () => {
    const formData = new FormData();
    formData.append("ReferralId", reAuthSubmitState?.referralId.toString());
    formData.append("RequestId", reAuthSubmitState?.requestId);
    formData.append("UserCreated", email);
    formData.append("DocumentData.ReferralBlobId", "0");
    formData.append("DocumentData.DocumentId", "11");
    formData.append("DocumentData.BlobId", "2");
    formData.append(
      "DocumentData.DateTimeReceived",
      formatDate(currentDate(true), DateFormats.MM_DD_YYYY)
    );
    formData.append("DocumentData.DocumentSourceId", "4");
    formData.append(
      "DocumentData.UserFullName",
      `${firstName} ${lastName} `
    );
    formData.append("ReferralDocumentDetail.Type", "2");
    formData.append("DocumentData.ReferralDocument", "");
    fileUpload.forEach((file: File, index: number) => {
      const updatedFile = new File(
        [file],
        appendTimestampToFilename(file.name, getFormattedDateTime(index + 1)),
        { type: file.type }
      );
      formData.append("referralDocumentList", updatedFile);
    });
    formData.append(
      "ReferralDocumentDetail.DocumentationDate",
      formatDate(currentDate(true), DateFormats.MM_DD_YYYY)
    );
    formData.append(
      "ReferralDocumentDetail.ServiceRequestId",
      reAuthSubmitState?.serviceRequestId.toString()
    );
    formData.append("ReferralDocumentDetail.ContainsSupportedDoc", "true");
    formData.append("DocumentData.isPortalDocument", "true");
    uploadDocumentFile(formData);

    postUserPageTrack(
      getUaserPageViewPayload(
        getValidMessageType(ApplicationTitles.CREATE_REAUTH),
        getCurrnetPageFullPath(),
        redirectUri,
        fileUpload.map((file) => file.name).join(",")
      )
    );
  };


  useEffect(() => {
    if (reAuthSubmitState.serviceRequestId > 0) {
      setShowAlert({
        message1: ResponseMessages(MessageType.RE_AUTH_CREATED),
        message2: `${reAuthReferralDetailState.authorizationNumber}`,
      });
    }
  }, [reAuthSubmitState]);
    useEffect(() => { 
      if (reAuthSubmitErrorState && reAuthSubmitErrorState.length > 0) {
        setShowAlert({
          message1: reAuthSubmitErrorState,
          message2: ``,
        });
      }
    }, [reAuthSubmitErrorState]);
  useEffect(() => {
    if (ingestProcessState && ingestProcessState.length > 5 && (reAuthSubmitState.serviceRequestId === 0)) {
      setShowAlert({
        message1: ResponseMessages(MessageType.INGEST_SUCCESS),
        message2: `${ingestProcessState}`,
      });
    }
  }, [ingestProcessState]);

  useEffect(() => {
    if (reAuthSubmitState.referralId > 0) {
      handleSaveFile();
    }
  }, [reAuthSubmitState]);
  useEffect(() => {
    if (
      ingestProcessErrorState &&
      ingestProcessErrorState.length > Numbers.ZERO
    ) {
      setApiValidationErrors([]);
      setErrorModal(true);
      setErrorMessage(ResponseMessages(MessageType.INGEST_PROCESS_FAILED));
    }

    const validationErrors = flattenApiValidationErrors(reAuthSubmitErrorState);
    if (typeof reAuthSubmitErrorState === "object" && reAuthSubmitErrorState !== null && validationErrors.length > 0) {
      setApiValidationErrors(validationErrors);
      setErrorModal(true);
      setErrorMessage(ResponseMessages(MessageType.RE_AUTH_NOT_CREATED));
      return;
    }

    if (
      reAuthSubmitErrorState &&
      typeof reAuthSubmitErrorState === "string" &&
      reAuthSubmitErrorState.length > Numbers.ZERO
    ) {
      setApiValidationErrors([]);
      setErrorModal(false);
      setErrorMessage(ResponseMessages(MessageType.RE_AUTH_NOT_CREATED));
    }
    return () => {
      resetStates(IngestProcessActionDispatchTypes.INGEST_PROCESS_RESET);
      resetStates(PostReAuthRequestDispatchTypes.POST_RE_AUTH_REQUEST_RESET);
    };
  }, [reAuthSubmitErrorState, ingestProcessErrorState]);

  /**Swal Visible */
  useEffect(() => {
    if (
      documentUploadState?.documentUploads &&
      documentUploadState?.documentUploads.length > 0
    ) {
      let failedCount = 0;
      documentUploadState?.documentUploads.forEach(
        (document: DocumentsUploadsResponse) => {
          if (document.status === "Failed") {
            failedCount++;
          }
        }
      );
      failedCount > 0 &&
        callFailedSwalVisible(
          documentUploadState,
          showAlert,
          setShowAlert,
          resetAPIResponse,
          reset
        );
      failedCount === 0 &&
        callSuccessSwalVisible(
          documentUploadState,
          showAlert,
          setShowAlert,
          resetAPIResponse,
          reset
        );
    }
  }, [documentUploadState]);

  useEffect(() => {
    if (
      documentUploadErrorState &&
      documentUploadErrorState.length > 0 &&
      documentUploadErrorState ===
        ResponseMessages(MessageType.DOCUMENT_NOT_UPLOADED)
    ) {
      callDocumentErrorSwal(
        documentUploadState,
        showAlert,
        setShowAlert,
        () => resetAPIResponse(Numbers.ONE),
        reset
      );
    }
  }, [documentUploadErrorState]);

  useEffect(() => {
    if (
      ingestProcessErrorState &&
      ingestProcessErrorState.length > Numbers.ZERO
    ) {
      setErrorModal(true);
    }
    return () => {
      resetStates(IngestProcessActionDispatchTypes.INGEST_PROCESS_RESET);
    };
  }, [ingestProcessErrorState]);

  return (
    <DetailBox>
      <Box sx={width100PCT}>
        <Grid container sx={ReferralGrid}>
          <Grid size={{ xs: 12 }}>
            <Box>
              <Box>
                <PatientHeaderTabs
                  value={currentTab}
                  onChange={handleChange}
                  aria-label="Patient Header Tabs"
                >
                  {ReAuthHeaderLabel.map((data, index) => (
                    <PatientHeaderTab
                      key={nanoid()}
                      label={data.label}
                      {...a11yProps(index)}
                    />
                  ))}
                </PatientHeaderTabs>
              </Box>
              <TabsPanelSection value={currentTab} index={0}>
                <AgencyDetails
                  control={control}
                  setValue={setValue}
                  getValues={getValues}
                  reset={reset}
                  clearErrors={clearErrors}
                />
              </TabsPanelSection>
              <TabsPanelSection value={currentTab} index={1}>
                <PhysicianDetails
                  control={control}
                  getValues={getValues}
                  setValue={setValue}
                  reset={reset}
                  watch={watch}
                  clearErrors={clearErrors}
                />
              </TabsPanelSection>
              <TabsPanelSection value={currentTab} index={2}>
                <ICD10
                  icdvalues={values}
                  control={control}
                  setValue={setValue}
                  getValues={getValues}
                  fields={icd10RecordsFields}
                  append={icd10RecordsAppend}
                  remove={icd10RecordsRemove}
                  reset={reset}
                  clearErrors={clearErrors}
                  watch={watch}
                  formState={formState}
                />
              </TabsPanelSection>
              <TabsPanelSection value={currentTab} index={3}>
                <RequestServices
                  control={control}
                  setValue={setValue}
                  reimbursementTypeId={0} //tbd
                  getValues={getValues}
                  reset={reset}
                />
              </TabsPanelSection>
              <TabsPanelSection value={currentTab} index={4}>
                <DocumentUpload
                  setValue={setValue}
                  control={control}
                  reset={reset}
                  getValues={getValues}
                  setFileUpload={setFileUpload}
                  fileUpload={fileUpload}
                />
              </TabsPanelSection>
              <TabsPanelSection value={currentTab} index={5}>
                <Review
                  tabSessionStorage={tabSessionStorage}
                  masterSendCommunicationAuthTypeState={
                    masterSendCommunicationAuthTypeState
                  }
                  files={fileUpload}
                  memberInfoDataState={memberInfoDataState}
                />
              </TabsPanelSection>
            </Box>
          </Grid>
        </Grid>
        <Grid container sx={flexAlignCentre}>
          <Grid size={{ xs: 6 }} sx={CancelButtonGrid}>
            <Button
              variant="outlined"
              sx={ButtonMinWidth_Outlined}
              onClick={() => {
                handleCancel();
                resetAPIResponse(1);
              }}
            >
              CANCEL
            </Button>
          </Grid>
          <Grid size={{ xs: 6 }} sx={NextButtonGrid}>
            {currentTab !== RequestReAuthTabCount ? (
              <>
                <Button
                  variant="outlined"
                  onClick={handleBackStep}
                  disabled={currentTab === 0}
                  sx={ButtonMinWidth_Outlined}
                >
                  PREVIOUS
                </Button>
                <Button
                  variant="contained"
                  sx={ButtonMinWidth}
                  onClick={handleNextStep}
                >
                  NEXT
                </Button>
              </>
            ) : (
              <Button
                onClick={() => handleSubmitReferral()}
                sx={ButtonMinWidth}
                variant="contained"
                disabled={notVisitedReAuthTabs(tabSessionStorage).length > 0}
              >
                Create Reauthorization Request
              </Button>
            )}
          </Grid>
        </Grid>
        <AlertDialog
          alertMessage={SaveDetailsAlertMessage}
          openAlert={openAlert}
          setOpenAlert={setOpenAlert}
          handleSubmit={handleSave}
          back={backClick}
          handleBackClick={handleBackClick}
        />
        {hasFormError && (
          <ErrorDialog
            hasFormError={hasFormError}
            setHasFormError={setHasFormError}
            formError={consolidatedErrors}
          />
        )}
         {showAlert && (getValue(reAuthSubmitState, 'serviceRequestId') > 0 || (ingestProcessState && ingestProcessState.length > 5) || (reAuthSubmitErrorState && reAuthSubmitErrorState.length > 0)) && (
        <SweetAlert
          message1={showAlert.message1}
          message2={showAlert.message2}
          onClose={() => {
            setShowAlert(null);
            setTimeout(() => {
              resetAPIResponse(1);
              handleCancel();
            }, 100);
          }}
        />
      )}
        {errorModal &&
          showMessageModal(
            errorModal,
            setErrorModal,
            errorMessage,
            undefined,
            false,
            apiValidationErrors,
          )}
        <ConfirmationDialog
          openConfirmation={openConfirmation}
          setOpenConfirmation={setOpenConfirmation}
          confirmationMessageTitle={confirmationMessage}
        />
      </Box>
    </DetailBox>
  );
};

export default ReAuthTabs;
